import { TMythicPlusTopRunsPaneProps } from '.';
import { TCommonSiteMeta } from '../../../../../../../../shared/frontend/scripts/selectors/global';
import { TSpecSummary } from '../../../../../../../../shared/types/utilityTypes';
import { TClassSummary } from '../../../../../../../../shared/types/utilityTypes';
import { TSiteConfigState } from '../../../../libs/store';
import { TGetKeystoneSpecRankingsParams } from '../../../../services/apiService';
import { TGetKeystoneRunRankingsParams } from '../../../../../../../../shared/frontend/scripts/services/commonApiService';

export const createTopMPlusRunsParams = (props: TMythicPlusTopRunsPaneProps): TGetKeystoneRunRankingsParams => ({
  season: props.seasonSlug,
  dungeon: 'all',
  region: props.region,
  strict: true,
  page: 0,
  limit: 5,
  minMythicLevel: 0,
  maxMythicLevel: 0,
  eventId: 0,
  faction: '',
  recent: false,
  realm: props.realm || 'all',
  period: 0
});

export const getTopMPlusInstanceId = (props: TMythicPlusTopRunsPaneProps) => {
  return `frontpage:timed:${props.seasonSlug}`;
};

export const createSpecParams = (
  params: Pick<TGetKeystoneSpecRankingsParams, 'season' | 'region' | 'class' | 'spec'>
): TGetKeystoneSpecRankingsParams => ({
  ...params,
  page: 0,
  pageSize: 5
});

export const getClassSpecBySiteMetaAndConfig = (siteMeta: TCommonSiteMeta, siteConfig: TSiteConfigState) => {
  const specs = siteMeta.specs as TSpecSummary[];
  const classes = siteMeta.classes;
  const seed = siteConfig.seed;
  const spec = specs[seed % specs.length] || specs[0];
  const cls = classes.find((c: TClassSummary) => c.id === spec.class_id)!;

  return { cls, spec };
};
